import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Button from '@mui/material/Button';
import { useIntl } from 'react-intl';

import { i18n } from './SalesforceLinkButton.i18n';

const SALESFORCE_BASE_URL = 'https://seequentglobal.lightning.force.com/';

interface SalesforceLinkButtonProps {
    salesforceLink: string;
}

export const SalesforceLinkButton = ({ salesforceLink }: SalesforceLinkButtonProps) => {
    const intl = useIntl();
    const trimmed = salesforceLink?.trim();
    if (!trimmed) return null;

    return (
        <Button
            component="a"
            href={`${SALESFORCE_BASE_URL}${trimmed}`}
            target="_blank"
            rel="noopener noreferrer"
            variant="outlined"
            startIcon={<OpenInNewIcon />}
            automation-id="salesforce-navigate-button"
        >
            {intl.formatMessage(i18n.navigateToSalesforce)}
        </Button>
    );
};
